import React from 'react';
import EmptyState from './EmptyState';
import { formatCurrency } from '../utils';

export default function TopAffiliatesTab({ topAffiliates }) {
  if (topAffiliates.length === 0) {
    return (
      <div className="rounded-2xl border border-slate-200/80 bg-white shadow-sm overflow-hidden">
        <div className="border-b border-slate-100 px-5 py-4">
          <h3 className="text-base font-semibold text-slate-900">Top affiliates</h3>
          <p className="mt-0.5 text-sm text-slate-500">By conversions and revenue</p>
        </div>
        <div className="p-12">
          <EmptyState
            message="No affiliates yet"
            subMessage="Top performers will appear here once links are used."
          />
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm">
      <div className="border-b border-slate-100 px-5 py-4">
        <h3 className="text-base font-semibold text-slate-900">Top affiliates</h3>
        <p className="mt-0.5 text-sm text-slate-500">By conversions and revenue</p>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-slate-100">
          <thead className="bg-slate-50/80">
            <tr>
              <th className="px-5 py-3 text-left text-xs font-medium uppercase tracking-wider text-slate-500">
                Affiliate
              </th>
              <th className="px-5 py-3 text-right text-xs font-medium uppercase tracking-wider text-slate-500">
                Links
              </th>
              <th className="px-5 py-3 text-right text-xs font-medium uppercase tracking-wider text-slate-500">
                Clicks
              </th>
              <th className="px-5 py-3 text-right text-xs font-medium uppercase tracking-wider text-slate-500">
                Conversions
              </th>
              <th className="px-5 py-3 text-right text-xs font-medium uppercase tracking-wider text-slate-500">
                Conv. rate
              </th>
              <th className="px-5 py-3 text-right text-xs font-medium uppercase tracking-wider text-slate-500">
                Revenue
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {topAffiliates.map((a, i) => (
              <tr key={a.userId?.toString() || i} className="hover:bg-slate-50/50">
                <td className="px-5 py-3">
                  <div className="flex items-center gap-2">
                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-orange-100 text-sm font-semibold text-orange-600">
                      {(a.name || 'U').charAt(0).toUpperCase()}
                    </div>
                    <div className="min-w-0">
                      <p className="text-sm font-medium text-slate-900">
                        {a.name || 'Unknown'}
                      </p>
                      {a.email && (
                        <p className="max-w-[200px] truncate text-xs text-slate-500">
                          {a.email}
                        </p>
                      )}
                    </div>
                  </div>
                </td>
                <td className="px-5 py-3 text-right text-sm text-slate-600">
                  {a.linksCount ?? 0}
                </td>
                <td className="px-5 py-3 text-right text-sm text-slate-600">
                  {(a.clicks ?? 0).toLocaleString()}
                </td>
                <td className="px-5 py-3 text-right text-sm text-slate-600">
                  {a.conversions ?? 0}
                </td>
                <td className="px-5 py-3 text-right text-sm text-slate-600">
                  {a.conversionRate != null
                    ? `${Number(a.conversionRate).toFixed(2)}%`
                    : '—'}
                </td>
                <td className="px-5 py-3 text-right text-sm font-medium text-slate-900">
                  {formatCurrency(a.revenue)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
